export const teamKeys = {
    all: ['teams'],
    list: (params) => ['teams', 'list', params],
    detail: (id) => ['teams', 'detail', id],
    members: (id) => ['teams', 'detail', id, 'members'],
    projectTeams: (params) => ['project-teams', params],
};
